/**
 * Slim progress bar shown during file uploads.
 * Renders nothing when percent is null/undefined (upload not active).
 */
export default function UploadProgress({ percent, label = "Uploading", className = "" }) {
  if (percent == null) return null;
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div data-testid="upload-progress" className={`w-full ${className}`}>
      <div className="flex items-center justify-between text-xs font-semibold text-slate-600 mb-1">
        <span>{label}</span>
        <span data-testid="upload-progress-value" className="tabular-nums">{clamped}%</span>
      </div>
      <div className="h-2 w-full bg-slate-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-blue-600 transition-[width] duration-150 ease-out"
          style={{ width: `${clamped}%` }}
          data-testid="upload-progress-bar"
        />
      </div>
    </div>
  );
}
